// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {


		//Call function with browser is resized.
		$(window).resize(function (event) {
			
		});
		
		// Main Nav Dropdown

		$("#primary-nav li").hover(function(){
			if( $(window).width() > 767 ){
				$(this).addClass("hover");
				$('ul.submenu',this).fadeIn(200);
			}
		}, function(){
			if( $(window).width() > 767 ){
				$(this).removeClass("hover");
				$('ul.submenu',this).fadeOut(200);
			}
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});
	
	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		var rellaX = document.querySelector('.rellax');
		if(rellaX){
			rellax.refresh();
		}
		scrolltales('.top-content-home__slide');
		scrolltales('#home .bg-pic__slide');
		//scrolltales('.top-content__slide');
		scrolltales('#home .list-white__item__slide', '.list-white__item');
		scrolltales('#home .sq-background__slide', '.sq-background');
		window.addEventListener('scroll', function(){
			scrollW();
			scrolltales('#home .top-content-home__slide');
			scrolltales('#home .bg-pic__slide');
			//scrolltales('.top-content__slide');
			scrolltales('#home .list-white__item__slide', '.list-white__item');
			scrolltales('#home .sq-background__slide', '.sq-background');
		})
		let iframe = document.querySelectorAll('#frmCheckout .g-recaptcha iframe');
		console.log(iframe);
		iframe.forEach(iframe => {
			iframe.setAttribute('aria-label', 'recapthca')
		});
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
		document.getElementsByTagName("BODY")[0].classList.add('scrolled');
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
		document.getElementsByTagName("BODY")[0].classList.remove('scrolled');
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative 
}
document.querySelectorAll('.circle-btn-top').forEach( el=>{
	var arcs = new CircleType(el).radius(55);
})
document.querySelectorAll('.circle-btn-bottom').forEach( el=>{
	var arcs = new CircleType(el).radius(55);
})


/* Accordion */
var accordionItems = document.querySelectorAll('.accordion__item');
var i;
for (i = 0; i < accordionItems.length; i++) {
	let disItem = accordionItems[i];
	let disBtn = disItem.querySelector('.accordion__btn');
	disBtn.addEventListener('click', function(){
		disItem.classList.toggle('open');
	});
}

/* Scroll to */
document.querySelectorAll('.scrollto').forEach(ele=>{
	ele.addEventListener('click', ev=>{
		ev.preventDefault();
		var targ = ele.getAttribute('href');
		var targPos = $(targ).offset().top - 110;
		$('html, body').animate({
			scrollTop: targPos
		}, 1200);
	})
});

/* Go to Hash and mobile submenu */
if($(window.location.hash).length > 0 ){
	console.log(window.location.hash)
	$('html, body').stop();
	$(window).load( function(){
		$('html, body').stop().delay(100).animate({ scrollTop: $(window.location.hash).offset().top - 110}, 1300);
	});
}
var submenubtns = document.querySelectorAll('.header .privary-navigation a');
submenubtns.forEach(e=>{
	e.addEventListener('click', function(ev){
		var detal = this.getAttribute('href');
		var dehash = detal.split('#');
		if(dehash[1]){
			var detarget = document.querySelector('#' + dehash[1]);
			console.log(detarget.length);
			if( detarget){
				ev.preventDefault();
				$('html, body').stop().delay(100).animate({ scrollTop: $(detarget).offset().top - 110}, 1300);
			}
		}else{
			var dadItem = this.closest('li');
			var childrenItems = dadItem.querySelectorAll('li');
			if(childrenItems.length && $(window).width() < 768){
				ev.preventDefault();
				$(dadItem).find('ul').slideToggle(500);
			}
		}
	});
});

/* Press titles */
// var presttitles = document.querySelectorAll('.press__item .title');
// presttitles.forEach(el=>{
// 	console.log(el.textContent.length);
// 	if(el.textContent.length > 50){
// 		var newstring = el.textContent.slice(0,50) + '…';
// 		el.textContent = newstring;
// 	}
// });

/* Rellax */
var rellaX = document.querySelector('.rellax');
if(rellaX){
	var rellax = new Rellax('.rellax', {
		breakpoints:[768]
	});
}


/* Custom Parallax */
function css(element, style) {
    for (const property in style)
        element.style[property] = style[property];
}
function scrolltales(ele, parentel){
	var elems = document.querySelectorAll(ele);
	if(elems){
		elems.forEach(dele=>{
			var ini = $(dele).offset().top - window.innerHeight;
			if( ini < 0){
				ini = 0;
			}
			var end = $(dele).offset().top + dele.offsetHeight;
			var numberRef = end - ini;
			var doc = document.documentElement;
			var topPos = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
			var posref =  topPos - ini;
			var ypallx = (100 * posref)/numberRef;
			if(ypallx > 100){
				ypallx = 100;
			}
			if(ypallx < 0){
				ypallx = 0;
			}
			css(dele, {
				'background-position': '50% '+ ypallx + '%',
			});
			if(parentel){
				var dad = dele.closest(parentel);
				if(ypallx > 25 && ypallx < 75){
					dad.classList.add('visible');
				}else{
					dad.classList.remove('visible');
				}
			}
		});
	}
}

/* Menu Mobile */
var hambbtn = document.querySelector('.hamburger__btn');
if(hambbtn){
	hambbtn.addEventListener('click', function () {
		var menuObj = document.querySelector('.header');
		if( menuObj.classList.contains('active') ){
			menuObj.classList.remove('active');
			document.querySelector('nav.buttons').classList.remove('menu-open');
		}else{
			menuObj.classList.add('active');
			document.querySelector('nav.buttons').classList.add('menu-open');
		}
	});
}
/* Add overview button on submenus */
var submenus = document.querySelectorAll('.privary-navigation__submenu');
if(submenus){
	submenus.forEach( ele=>{
		var dadEle = ele.parentElement;
		var link = dadEle.children[0];
		var linkHref = link.getAttribute('href');
		var linktext = link.innerHTML;
		var newLi = document.createElement("li");
		newLi.innerHTML = '<a class="d-md-none" href="' + linkHref + '">' + linktext + ' overview</a>';
		ele.prepend(newLi);
	});
}

/* Read more */
var readMoreBtns = document.querySelectorAll('.readmore-toggle');
if(readMoreBtns){
	readMoreBtns.forEach( ele =>{
		ele.addEventListener('click', eve =>{
			eve.preventDefault();
			ele.classList.toggle('active');
			var targ = ele.getAttribute('href');
			var targetEl = document.querySelector(targ);
			if(ele.classList.contains('active')){
				var elHeight = targetEl.scrollHeight;
				targetEl.classList.add('active');
			}else{
				var elHeight = 0;
				targetEl.classList.remove('active');
			}
			css(targetEl, {
				'height': elHeight + 'px',
			});
		});
	});
}


$('.sym-slides').slick({
	accessibility: false
});

